module.exports = require("@aws-sdk/client-sqs");